import { createAction, isAction } from '@reduxjs/toolkit';

import { prefetchManager } from './apiSSRModule/prefetchManager';
import { AnyApi } from './buildCreateApi';
import { createInvalidateTagsActionMatcher } from './patchApiReducer/actions/createInvalidateTagsActionMatcher';

export const resetAllApisState = /* @__PURE__ */ createAction('@@modules/testing/resetAllApisState');

/**
 * Добавляет в стор внутренний экшен для сброса состояния всех RTK Query API сразу.
 */
export function resetAllApisMiddleware(api: AnyApi): AnyApi['middleware'] {
    return mwApi => next => {
        const isInvalidateTagsAction = createInvalidateTagsActionMatcher(api);

        return action => {
            if (resetAllApisState.match(action)) {
                mwApi.dispatch(api.util.resetApiState());
            }

            /**
             * Если метод `api.util.invalidateTags` вызывается для запросов БЕЗ подписок,
             * то RTK Query удаляет закешированные данные СРАЗУ ЖЕ, не дожидаясь keepUnusedDataFor
             *
             * Отслеживаем такие вызовы и удаляем соответствующие prefetch-подписки
             */
            if (isAction(action) && isInvalidateTagsAction(action)) {
                const invalidatedBy = api.util.selectInvalidatedBy(mwApi.getState(), action.payload);

                for (const { queryCacheKey } of invalidatedBy) {
                    prefetchManager.remove(`${api.reducerPath}/${queryCacheKey}`);
                }
            }

            return next(action);
        };
    };
}
